import { render, staticRenderFns } from "./SegmentedControls.vue?vue&type=template&id=6fa9ea51&scoped=true&"
import script from "./SegmentedControls.vue?vue&type=script&lang=js&"
export * from "./SegmentedControls.vue?vue&type=script&lang=js&"
import style0 from "./SegmentedControls.vue?vue&type=style&index=0&id=6fa9ea51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa9ea51",
  null
  
)

export default component.exports